'use client';

import { SkipLinksContent } from '@coolblue-development/freddy';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  id?: string;
};

const Content = ({ id, children }: Props) => {
  return <SkipLinksContent id={id ?? 'main-content'}>{children}</SkipLinksContent>;
};

export default Content;
